import React from 'react';
import { Box, Typography, Paper, Divider, Button, Grid } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from 'react-router-dom';
import DocSidebar from './DocSidebar';

const DocumentationPage = () => {
  const history = useHistory();

  return (
    <Box sx={{ display: 'flex', height: '100vh', overflowY:'hidden' }}>
      {/* Sidebar */}
      

      {/* Main Content */}
      <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 4 }}>
        <Button startIcon={<ArrowBackIcon />} sx={{ mb: 4, color: '#1976d2' }} onClick={() => history.push('/explore')}>
          Back to Explore
        </Button>

        <Typography variant="h3" sx={{ mb: 4, fontWeight: 'bold', color: '#1976d2' }}>
          KaleidEO Platform User Guide
        </Typography>

        <IntroSection />

        <Grid container spacing={4}>
          {sections.map((section, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Paper 
                elevation={3} 
                sx={{ p: 3, borderRadius: 2, bgcolor: 'background.paper', cursor: 'pointer', transition: '0.3s', '&:hover': { boxShadow: 6 } }} 
                onClick={() => history.push(`/documentation/${section.route}`)}
              >
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>{section.title}</Typography>
                <Typography variant="body2" color="text.secondary">{section.summary}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: 6 }} />

        {/* <QuickReference /> */}

        {/* Download Full PDF button commented out */}
        {/* <Button variant="outlined" sx={{ mt: 4, borderColor: '#1976d2', color: '#1976d2' }}>
          Download Full PDF (Coming Soon)
        </Button> */}
      </Box>
    </Box>
  );
};

const IntroSection = () => (
  <Box sx={{ mb: 6 }}>
    <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
      Welcome to KaleidEO
    </Typography>
    <Typography variant="body1" color="text.secondary">
      Discover, browse, and order satellite imagery through a user-friendly platform designed for both archival catalog search and new tasking requests. Navigate seamlessly from map exploration to image checkout and delivery.
    </Typography>
  </Box>
);

const QuickReference = () => (
  <Box>
    <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>Quick Reference</Typography>
    <Paper elevation={1} sx={{ p: 3, bgcolor: '#f9f9f9', borderRadius: 2 }}>
      <Typography variant="body2" sx={{ mb: 1 }}><strong>Login/Register:</strong> /login</Typography>
      <Typography variant="body2" sx={{ mb: 1 }}><strong>Explore Map:</strong> /explore</Typography>
      <Typography variant="body2" sx={{ mb: 1 }}><strong>Place Catalog Order:</strong> Explore → Catalog Tab</Typography>
      <Typography variant="body2" sx={{ mb: 1 }}><strong>Place Tasking Order:</strong> Explore → Tasking Tab</Typography>
      <Typography variant="body2" sx={{ mb: 1 }}><strong>Track Orders:</strong> /orders</Typography>
      <Typography variant="body2"><strong>Manage Profile:</strong> /profile</Typography>
    </Paper>
  </Box>
);

const sections = [
  // {
  //   title: 'Authentication',
  //   summary: 'Login and register to access platform features.',
  //   route: 'authentication'
  // },
  {
    title: 'Getting Started',
    summary: 'Navigate the map, draw AOIs, and select operations.',
    route: 'explore'
  },
  {
    title: 'Catalog Imagery',
    summary: 'Order and Browse available archival/Catalog Imagery',
    route: 'catalog-imagery'
  },
  {
    title: 'Task an Image',
    summary: 'Task a Satellite to obtain new Imagery',
    route: 'task-an-image'
  },
  {
    title: 'Order and Data Management',
    summary: 'Track and manage your imagery orders.',
    route: 'order-management'
  }
];

export default DocumentationPage;